import React from 'react'
import Logo from '../../Logos/Logo'
import { Button } from 'antd'
import './googleButton.less'
import { useTranslation } from 'react-i18next'

interface IProps {
  handleGoogleOAuth: () => void
}

const GoogleButton = ({ handleGoogleOAuth }: IProps) => {
  const { t } = useTranslation('components')

  return (
    <Button
      type="link"
      icon={<Logo name="Google" width="100%" height="100%" className="integration-icon" />}
      className="integration-btn"
      size="large"
      onClick={handleGoogleOAuth}
    >
      {t('ui.googleButton.connectGoogleAccount')}
    </Button>
  )
}

export default GoogleButton
